/**
 * PLTX2 Review Form — the write-a-review sheet
 *
 *   Step 1: Rating + title + body
 *   Step 2: Photos (up to 3) + voice recording — optional
 *   Step 3: Email
 *   Step 4: One-time code → submit
 *   Step 5: Thanks
 *
 * Markup: snippets/pltx2-review-form.liquid   Styles: assets/pltx2-review-form.css
 * The global function names (openModal, closeModal, showStep, pickStar, goBack,
 * updateCharCount, validateEmail, sendVerifyEmail, resendOtp) are called from inline
 * handlers in the snippet and in sections/reviews-vertical.liquid — keep them.
 *
 * Card display, filtering, thumbs and the photo lightbox live in pltx2-reviews-vertical.js.
 * This file is ONLY the write flow.
 *
 * 2026-10-13 rebuild: one sheet with a fixed bar + fixed footer (no drag-to-dismiss, the
 * button never scrolls off screen), height eases between steps, sheet pinned to the visual
 * viewport so the keyboard never covers it, the scroll lock measures the scrollbar BEFORE
 * hiding it (it measured after, always got 0, and the header jumped 15px), photo slots
 * actually upload now (they had no handler), and a half-written review survives closing.
 */

// ===== STATE =====

var reviewsState = {
  apiBase: '',
  productId: '',
  _uploadedPhotos: [],
  _uploadedVoiceUrl: null,
  _uploadedVoiceDurationMs: null,
  _uploadedVoiceWaveform: []
};

(function initReviewsStateFromSection() {
  var section = document.querySelector('.pltx2-vertical');
  if (!section) return;
  reviewsState.apiBase = section.getAttribute('data-api-base') || '';
  reviewsState.productId = section.getAttribute('data-product-id') || '';
})();

var currentStep = 1;
var selectedRating = 0;
var totalSteps = 5;
var resendInterval = null;
var rfFinished = false;      // reached the thank-you step → next open starts clean
var rfOpener = null;         // element that opened the sheet, gets focus back on close
var rfPhotoSlots = [null, null, null]; // { previewUrl, url, busy }
var RF_EMOJI = ['', '😞', '😕', '🙂', '😊', '🤩'];
var RF_LABEL_FALLBACK = ['בחרי דירוג', 'גרוע', 'לא טוב', 'בסדר', 'טוב מאוד', 'מצוין!'];

function rf$(id) { return document.getElementById(id); }
function rfSheet() { return rf$('modalSheet'); }
function rfText(attr, fallback) {
  var s = rfSheet();
  var v = s && s.getAttribute('data-' + attr);
  return v || fallback || '';
}

// ===== SCROLL LOCK =====
// Measure the scrollbar while it still exists, then hide it and pad the body by the same
// amount on the side it lived on (right in Chrome even for RTL, left in Firefox RTL).

var rfLock = { on: false, side: 'right', fixed: null };

function rfLockScroll() {
  if (rfLock.on) return;
  var html = document.documentElement;
  var box = html.getBoundingClientRect();
  var bar = window.innerWidth - box.width; // fractional: clientWidth rounds and leaves a sub-pixel wobble
  rfLock.side = box.left > 0.5 ? 'left' : 'right';
  document.body.style.overflow = 'hidden';
  if (bar > 0.5) {
    document.body.style[rfLock.side === 'left' ? 'paddingLeft' : 'paddingRight'] = bar + 'px';
    // Full-width fixed bars ignore body padding — hold them at the width they had.
    rfLock.fixed = Array.prototype.filter.call(document.querySelectorAll('sticky-atc'), function (el) {
      var cs = getComputedStyle(el);
      return cs.position === 'fixed' && cs.left === '0px' && cs.right === '0px';
    });
    rfLock.fixed.forEach(function (el) {
      el.style.width = box.width + 'px';
      if (rfLock.side === 'left') el.style.left = bar + 'px';
    });
  }
  rfLock.on = true;
}

function rfUnlockScroll() {
  if (!rfLock.on) return;
  document.body.style.overflow = '';
  document.body.style.paddingLeft = '';
  document.body.style.paddingRight = '';
  (rfLock.fixed || []).forEach(function (el) { el.style.left = ''; el.style.width = ''; });
  rfLock.fixed = null;
  rfLock.on = false;
}

// ===== VISUAL VIEWPORT (mobile keyboard) =====
// Pin the overlay to the visible area so the on-screen keyboard pushes the sheet up
// instead of covering the field and the button.

function rfFitViewport() {
  var overlay = rf$('modalOverlay');
  var vv = window.visualViewport;
  if (!overlay || !vv) return;
  overlay.style.top = vv.offsetTop + 'px';
  overlay.style.height = vv.height + 'px';
  overlay.style.bottom = 'auto';
}

function rfReleaseViewport() {
  var overlay = rf$('modalOverlay');
  if (!overlay) return;
  overlay.style.top = '';
  overlay.style.height = '';
  overlay.style.bottom = '';
}

// ===== MODAL OPEN / CLOSE =====

function openModal() {
  var overlay = rf$('modalOverlay');
  var sheet = rfSheet();
  if (!overlay || !sheet) return;

  // Escape any transformed ancestor (the section reveal system) so position:fixed is the viewport.
  if (overlay.parentElement !== document.body) document.body.appendChild(overlay);

  if (rfFinished) rfResetForm();
  rfOpener = document.activeElement;

  rfLockScroll();
  overlay.style.display = 'flex';
  rfFitViewport();
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', rfFitViewport);
    window.visualViewport.addEventListener('scroll', rfFitViewport);
  }
  showStep(1, true);
  void overlay.offsetHeight; // commit the closed position before animating in
  overlay.classList.add('visible');
  sheet.classList.add('is-open');

  setTimeout(function () {
    var first = selectedRating ? rf$('star' + selectedRating) : rf$('star1');
    if (first && overlay.classList.contains('visible')) first.focus({ preventScroll: true });
  }, 360);
}

function closeModal() {
  var overlay = rf$('modalOverlay');
  var sheet = rfSheet();
  if (!overlay || !sheet || overlay.style.display !== 'flex') return;

  if (document.activeElement && sheet.contains(document.activeElement)) document.activeElement.blur();
  sheet.classList.remove('is-open');
  overlay.classList.remove('visible');
  if (window.visualViewport) {
    window.visualViewport.removeEventListener('resize', rfFitViewport);
    window.visualViewport.removeEventListener('scroll', rfFitViewport);
  }

  setTimeout(function () {
    if (sheet.classList.contains('is-open')) return; // reopened meanwhile
    overlay.style.display = 'none';
    rfReleaseViewport();
    rfUnlockScroll();
    if (resendInterval) { clearInterval(resendInterval); resendInterval = null; }
    if (rfOpener && rfOpener.focus) rfOpener.focus({ preventScroll: true });
    rfOpener = null;
  }, 380);
}

// Start a clean form (after a review went through).
function rfResetForm() {
  rfFinished = false;
  selectedRating = 0;
  paintStars(0, false);
  rfSetRatingLabel(0);
  ['reviewTitle', 'reviewBody', 'emailInput'].forEach(function (id) { var el = rf$(id); if (el) el.value = ''; });
  updateCharCount();
  validateEmail();
  var otps = document.querySelectorAll('.otp-input');
  for (var i = 0; i < otps.length; i++) { otps[i].value = ''; otps[i].disabled = false; otps[i].classList.remove('is-filled'); }
  for (var s = 0; s < rfPhotoSlots.length; s++) rfClearSlot(s);
  if (typeof window.pltx2RfResetVoice === 'function') window.pltx2RfResetVoice();
  reviewsState._uploadedVoiceUrl = null;
  reviewsState._uploadedVoiceDurationMs = null;
  reviewsState._uploadedVoiceWaveform = [];
  ['emailError', 'otpError', 'pltx2RfPhotoError'].forEach(function (id) { var el = rf$(id); if (el) el.hidden = true; });
}

// ===== STEP NAVIGATION =====

function showStep(num, instant) {
  var sheet = rfSheet();
  if (!sheet) return;
  var animate = !instant && sheet.classList.contains('is-open');
  var from = animate ? sheet.offsetHeight : 0;

  currentStep = num;
  var target = null;
  for (var i = 1; i <= totalSteps; i++) {
    var el = rf$('formStep' + i);
    if (!el) continue;
    if (i === num) { el.hidden = false; target = el; } else { el.hidden = true; }
  }

  if (target) {
    target.classList.remove('is-entering');
    void target.offsetWidth;
    target.classList.add('is-entering');
    var scroller = target.querySelector('.pltx2-rf__scroll');
    if (scroller) scroller.scrollTop = 0;
  }

  // Ease the sheet from its old height to the new step's height.
  if (animate) {
    sheet.style.height = '';
    var to = sheet.offsetHeight;
    if (Math.abs(to - from) > 2) {
      sheet.style.height = from + 'px';
      void sheet.offsetHeight;
      sheet.classList.add('is-sizing');
      sheet.style.height = to + 'px';
      clearTimeout(sheet._rfSizeT);
      sheet._rfSizeT = setTimeout(function () {
        sheet.classList.remove('is-sizing');
        sheet.style.height = '';
      }, 320);
    }
  }

  updateDots(num);
  updateBackButton(num);
  sheet.classList.toggle('is-finished', num === totalSteps);

  if (num === 2) rfSyncStep2Button();
  if (num === 3) {
    setTimeout(function () { var e = rf$('emailInput'); if (e && currentStep === 3) e.focus({ preventScroll: true }); }, 320);
  }
  if (num === 4) {
    startResendTimer();
    updateMaskedEmail();
    setTimeout(function () {
      var first = document.querySelector('.otp-input[data-idx="0"]');
      if (first && currentStep === 4) first.focus({ preventScroll: true });
    }, 320);
  }
  if (num === totalSteps) {
    rfFinished = true;
    if (navigator.vibrate) navigator.vibrate([12, 40, 18]);
  }
}

function updateBackButton(step) {
  var btn = rf$('modalBack');
  if (!btn) return;
  var on = step >= 2 && step <= 4;
  btn.classList.toggle('visible', on);
  btn.tabIndex = on ? 0 : -1;
  btn.setAttribute('aria-hidden', on ? 'false' : 'true');
}

function goBack() {
  if (currentStep > 1 && currentStep <= 4) showStep(currentStep - 1);
}

function updateDots(active) {
  for (var i = 1; i <= 4; i++) {
    var seg = rf$('dot' + i);
    if (!seg) continue;
    seg.classList.toggle('is-done', i < active || active === totalSteps);
    seg.classList.toggle('is-active', i === active && active !== totalSteps);
  }
  var bar = rf$('pltx2RfProgress');
  if (bar) bar.setAttribute('aria-valuenow', String(Math.min(active, 4)));
}

// ===== STEP 1: RATING + TEXT =====

function paintStars(n, pop) {
  for (var i = 1; i <= 5; i++) {
    var star = rf$('star' + i);
    if (!star) continue;
    star.classList.toggle('is-on', i <= n);
    star.setAttribute('aria-checked', i === n ? 'true' : 'false');
    star.classList.remove('is-pop');
    if (pop && i <= n) {
      star.style.setProperty('--d', String(i - 1));
      void star.offsetWidth;
      star.classList.add('is-pop');
    }
  }
}

function rfSetRatingLabel(n) {
  var el = rf$('ratingLabel');
  if (!el) return;
  var text = rfText('label-' + n, RF_LABEL_FALLBACK[n]);
  el.textContent = n ? RF_EMOJI[n] + ' ' + text : text;
  el.classList.remove('is-set');
  if (n) { void el.offsetWidth; el.classList.add('is-set'); }
}

function pickStar(n) {
  selectedRating = n;
  paintStars(n, true);
  rfSetRatingLabel(n);
  if (navigator.vibrate) navigator.vibrate(12);
  updateStep1Validation();
}

function updateStep1Validation() {
  var ta = rf$('reviewBody');
  var len = ta ? ta.value.trim().length : 0;
  var btn = rf$('btnStep1Next');
  if (btn) btn.disabled = !(selectedRating > 0 && len >= 5);
}

function updateCharCount() {
  var ta = rf$('reviewBody');
  var el = rf$('charCount');
  if (!ta || !el) return;
  var len = ta.value.length;
  // Grow with the text (up to ~7 lines) instead of showing a scrollbar inside the box.
  ta.style.height = '';
  if (ta.scrollHeight > ta.clientHeight) {
    var borders = ta.offsetHeight - ta.clientHeight;
    ta.style.height = Math.min(ta.scrollHeight + borders, 220) + 'px';
  }
  ta.style.overflowY = ta.scrollHeight > ta.clientHeight ? 'auto' : 'hidden';
  if (len > 0 && len < 5) {
    el.textContent = len + pltxT('pltx2.js.k006', '/2000 · עוד ') + (5 - len) + pltxT('pltx2.js.k005', ' תווים נדרשים');
    el.classList.add('is-short');
  } else {
    el.textContent = len + '/2000';
    el.classList.remove('is-short');
  }
  updateStep1Validation();
}

// Desktop hover preview on the stars.
(function () {
  var row = rf$('ratingStars');
  if (!row || !window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;
  row.addEventListener('mouseover', function (e) {
    var star = e.target.closest && e.target.closest('.pltx2-rf__star');
    if (!star) return;
    var n = Number(star.getAttribute('data-n')) || 0;
    for (var i = 1; i <= 5; i++) rf$('star' + i).classList.toggle('is-hover', i <= n && i > selectedRating);
  });
  row.addEventListener('mouseleave', function () {
    for (var i = 1; i <= 5; i++) rf$('star' + i).classList.remove('is-hover');
  });
})();

// ===== STEP 2: PHOTOS =====

function rfPhotoError(msg) {
  var el = rf$('pltx2RfPhotoError');
  if (!el) return;
  el.textContent = msg || '';
  el.hidden = !msg;
}

function rfSyncPhotos() {
  reviewsState._uploadedPhotos = rfPhotoSlots.filter(function (s) { return s && s.url; }).map(function (s) { return s.url; });
  rfSyncStep2Button();
}

function rfSyncStep2Button() {
  var busy = rfPhotoSlots.some(function (s) { return s && s.busy; });
  var next = rf$('btnStep2Next');
  if (next) { next.disabled = busy; next.classList.toggle('is-loading', busy); }
}

function rfClearSlot(i) {
  var slot = rfPhotoSlots[i];
  if (slot && slot.previewUrl) URL.revokeObjectURL(slot.previewUrl);
  rfPhotoSlots[i] = null;
  var box = document.querySelector('.pltx2-rf__photo[data-slot="' + i + '"]');
  if (box) {
    box.classList.remove('has-img', 'is-busy');
    var img = box.querySelector('img'); if (img) img.remove();
    var x = box.querySelector('.pltx2-rf__photo-x'); if (x) x.remove();
    var add = box.querySelector('.pltx2-rf__photo-add'); if (add) add.hidden = false;
  }
  rfSyncPhotos();
}

// Re-encode to a JPEG of at most 1600px: smaller upload, turns HEIC/PNG into a format the
// server accepts, and drops EXIF (phone photos carry GPS coordinates).
function rfShrinkImage(file) {
  return new Promise(function (resolve) {
    var url = URL.createObjectURL(file);
    var img = new Image();
    img.onload = function () {
      var max = 1600;
      var scale = Math.min(1, max / Math.max(img.naturalWidth, img.naturalHeight));
      var w = Math.round(img.naturalWidth * scale);
      var h = Math.round(img.naturalHeight * scale);
      var canvas = document.createElement('canvas');
      canvas.width = w; canvas.height = h;
      canvas.getContext('2d').drawImage(img, 0, 0, w, h);
      URL.revokeObjectURL(url);
      canvas.toBlob(function (blob) { resolve(blob || file); }, 'image/jpeg', 0.86);
    };
    img.onerror = function () { URL.revokeObjectURL(url); resolve(file); };
    img.src = url;
  });
}

function rfAddPhoto(file, i) {
  var box = document.querySelector('.pltx2-rf__photo[data-slot="' + i + '"]');
  if (!box) return;
  var previewUrl = URL.createObjectURL(file);
  var slot = { previewUrl: previewUrl, url: null, busy: true };
  rfPhotoSlots[i] = slot;

  var add = box.querySelector('.pltx2-rf__photo-add'); if (add) add.hidden = true;
  var img = document.createElement('img');
  img.src = previewUrl; img.alt = ''; img.draggable = false;
  box.appendChild(img);
  var x = document.createElement('button');
  x.type = 'button';
  x.className = 'pltx2-rf__photo-x';
  x.setAttribute('aria-label', rfText('remove-photo', '✕'));
  x.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  x.addEventListener('click', function (e) { e.stopPropagation(); rfClearSlot(i); });
  box.appendChild(x);
  box.classList.add('has-img', 'is-busy');
  rfSyncPhotos();

  rfShrinkImage(file).then(function (blob) {
    if (rfPhotoSlots[i] !== slot) return null;
    var okType = /^image\/(jpeg|png|webp)$/.test(blob.type);
    if (!okType) throw new Error('type');
    return uploadReviewMedia(blob, 'photo');
  }).then(function (data) {
    if (!data || rfPhotoSlots[i] !== slot) return;
    slot.url = data.url;
    slot.busy = false;
    box.classList.remove('is-busy');
    rfSyncPhotos();
  }).catch(function (err) {
    console.error('Photo upload failed:', err);
    if (rfPhotoSlots[i] !== slot) return;
    rfClearSlot(i);
    rfPhotoError(rfText('upload-error', 'לא הצלחנו להעלות את התמונה'));
  });
}

(function initPhotos() {
  var grid = rf$('photoSlots');
  var input = rf$('pltx2RfPhotoInput');
  if (!grid || !input) return;
  grid.addEventListener('click', function (e) {
    var add = e.target.closest && e.target.closest('.pltx2-rf__photo-add');
    if (!add) return;
    rfPhotoError('');
    input.click();
  });
  input.addEventListener('change', function () {
    var files = Array.prototype.slice.call(input.files || []);
    input.value = '';
    for (var f = 0; f < files.length; f++) {
      var free = rfPhotoSlots.indexOf(null);
      if (free === -1) break;
      if (!/^image\//.test(files[f].type) && !/\.(heic|heif)$/i.test(files[f].name)) continue;
      rfAddPhoto(files[f], free);
    }
  });
})();

// ===== STEP 3: EMAIL =====

function validateEmail() {
  var input = rf$('emailInput');
  var btn = rf$('btnVerifyEmail');
  if (!input || !btn) return;
  btn.disabled = !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value.trim());
}

function updateMaskedEmail() {
  var input = rf$('emailInput');
  var email = input ? input.value.trim() : '';
  if (email && email.indexOf('@') > 0) {
    var parts = email.split('@');
    rf$('maskedEmail').textContent = parts[0].charAt(0) + '***@' + parts[1];
  }
}

function startResendTimer() {
  var seconds = 60;
  var btn = rf$('resendBtn');
  if (!btn) return;
  var label = rfText('resend', 'שלח שוב');
  btn.disabled = true;
  btn.innerHTML = '';
  btn.appendChild(document.createTextNode(label + ' ('));
  var t = document.createElement('span'); t.id = 'resendTimer'; t.textContent = String(seconds);
  btn.appendChild(t);
  btn.appendChild(document.createTextNode(')'));
  if (resendInterval) clearInterval(resendInterval);
  resendInterval = setInterval(function () {
    seconds--;
    var timerEl = rf$('resendTimer');
    if (timerEl) timerEl.textContent = String(seconds);
    if (seconds <= 0) {
      clearInterval(resendInterval);
      resendInterval = null;
      btn.disabled = false;
      btn.textContent = label;
    }
  }, 1000);
}

function resendOtp() {
  sendVerifyEmail();
}

// ===== STEP 3 → 4: SEND VERIFICATION EMAIL =====

function sendVerifyEmail() {
  var btn = rf$('btnVerifyEmail');
  var emailInput = rf$('emailInput');
  var errorEl = rf$('emailError');
  if (!btn || !emailInput) return;

  var email = emailInput.value.trim();
  if (!email) return;

  btn.disabled = true;
  btn.classList.add('is-loading');
  if (errorEl) errorEl.hidden = true;

  fetch(reviewsState.apiBase + '/api/reviews/verify-email', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email: email, productId: reviewsState.productId, language: 'he' })
  })
    .then(function (r) { return r.json().then(function (d) { return { status: r.status, data: d }; }); })
    .then(function (result) {
      btn.classList.remove('is-loading');
      btn.disabled = false;
      if (result.status === 200 && result.data.success !== false) {
        if (currentStep === 4) startResendTimer(); else showStep(4);
      } else if (errorEl) {
        errorEl.textContent = result.data.error || pltxT('pltx2.js.k087', 'שגיאה בשליחת קוד האימות');
        errorEl.hidden = false;
      }
    })
    .catch(function (err) {
      console.error('verify-email error:', err);
      btn.classList.remove('is-loading');
      btn.disabled = false;
      if (errorEl) {
        errorEl.textContent = pltxT('pltx2.js.k089', 'שגיאת רשת. נסי שוב.');
        errorEl.hidden = false;
      }
    });
}

// ===== STEP 4 → 5: VERIFY OTP + SUBMIT REVIEW =====

function submitOtpAndReview() {
  var emailInput = rf$('emailInput');
  var errorEl = rf$('otpError');
  var email = emailInput ? emailInput.value.trim() : '';

  var inputs = document.querySelectorAll('.otp-input');
  var code = '';
  for (var i = 0; i < inputs.length; i++) code += inputs[i].value;
  if (code.length < 6) return;

  var reviewBody = rf$('reviewBody');
  var reviewTitle = rf$('reviewTitle');
  rfSyncPhotos();

  var reviewData = {
    rating: selectedRating,
    title: reviewTitle ? reviewTitle.value.trim() : '',
    body: reviewBody ? reviewBody.value.trim() : '',
    photos: reviewsState._uploadedPhotos || [],
    voiceUrl: reviewsState._uploadedVoiceUrl || null,
    voiceDurationMs: reviewsState._uploadedVoiceDurationMs || null,
    voiceWaveform: reviewsState._uploadedVoiceWaveform || [],
    locale: 'he'
  };

  for (var j = 0; j < inputs.length; j++) inputs[j].disabled = true;
  if (errorEl) errorEl.hidden = true;

  fetch(reviewsState.apiBase + '/api/reviews/verify-otp', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email: email, code: code, productId: reviewsState.productId, review: reviewData })
  })
    .then(function (r) { return r.json().then(function (d) { return { status: r.status, data: d }; }); })
    .then(function (result) {
      if (result.status === 200 && result.data.success) {
        showStep(5);
      } else {
        rfOtpFailed(result.data.error || pltxT('pltx2.js.k080', 'קוד שגוי. נסי שוב.'), true);
      }
    })
    .catch(function (err) {
      console.error('verify-otp error:', err);
      rfOtpFailed(pltxT('pltx2.js.k089', 'שגיאת רשת. נסי שוב.'), false);
    });
}

function rfOtpFailed(msg, clear) {
  var errorEl = rf$('otpError');
  var inputs = document.querySelectorAll('.otp-input');
  if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; }
  for (var k = 0; k < inputs.length; k++) {
    inputs[k].disabled = false;
    if (clear) { inputs[k].value = ''; inputs[k].classList.remove('is-filled'); }
  }
  var row = rf$('otpInputs');
  if (row) { row.classList.remove('is-shake'); void row.offsetWidth; row.classList.add('is-shake'); }
  if (navigator.vibrate) navigator.vibrate([30, 40, 30]);
  if (inputs[0]) inputs[0].focus({ preventScroll: true });
}

// ===== OTP AUTO-FOCUS + AUTO-SUBMIT =====

(function () {
  var inputs = document.querySelectorAll('.otp-input');
  if (!inputs.length) return;

  function fill(fromIdx, digits) {
    for (var j = 0; j < digits.length && fromIdx + j < inputs.length; j++) {
      inputs[fromIdx + j].value = digits.charAt(j);
      inputs[fromIdx + j].classList.add('is-filled');
    }
    var next = Math.min(fromIdx + digits.length, inputs.length - 1);
    inputs[next].focus({ preventScroll: true });
    maybeSubmit();
  }
  function maybeSubmit() {
    for (var j = 0; j < inputs.length; j++) if (!inputs[j].value) return;
    setTimeout(submitOtpAndReview, 250);
  }

  for (var i = 0; i < inputs.length; i++) {
    (function (idx) {
      inputs[idx].addEventListener('input', function () {
        var val = this.value.replace(/\D/g, '');
        if (val.length > 1) { fill(idx, val); return; } // SMS / email autofill drops the whole code here
        this.value = val;
        this.classList.toggle('is-filled', !!val);
        if (val && idx < inputs.length - 1) inputs[idx + 1].focus({ preventScroll: true });
        maybeSubmit();
      });
      inputs[idx].addEventListener('keydown', function (e) {
        if (e.key === 'Backspace' && !this.value && idx > 0) inputs[idx - 1].focus({ preventScroll: true });
      });
      inputs[idx].addEventListener('focus', function () { this.select && this.select(); });
      inputs[idx].addEventListener('paste', function (e) {
        e.preventDefault();
        var paste = (e.clipboardData || window.clipboardData).getData('text').replace(/\D/g, '');
        if (paste) fill(0, paste.slice(0, inputs.length));
      });
    })(i);
  }
})();

// ===== KEYBOARD: Escape closes, Tab stays inside the sheet =====

document.addEventListener('keydown', function (e) {
  var overlay = rf$('modalOverlay');
  if (!overlay || overlay.style.display !== 'flex') return;
  if (e.key === 'Escape') { closeModal(); return; }
  if (e.key !== 'Tab') return;
  var sheet = rfSheet();
  var nodes = Array.prototype.filter.call(
    sheet.querySelectorAll('button, input, textarea, audio[controls], [tabindex]:not([tabindex="-1"])'),
    function (el) { return !el.disabled && el.tabIndex !== -1 && el.offsetParent !== null; }
  );
  if (!nodes.length) return;
  var first = nodes[0], last = nodes[nodes.length - 1];
  if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
  else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
});

// ===== MEDIA UPLOAD =====

function uploadReviewMedia(file, type) {
  var formData = new FormData();
  formData.append('file', file, type === 'photo' ? 'photo.jpg' : (file.name || 'voice'));
  formData.append('type', type);
  return fetch(reviewsState.apiBase + '/api/reviews/upload-media', {
    method: 'POST',
    body: formData
  }).then(function (r) { return r.json(); })
    .then(function (data) {
      if (!data.success) throw new Error(data.error || 'Upload failed');
      if (type === 'voice') {
        reviewsState._uploadedVoiceUrl = data.url;
        if (data.voiceDurationMs) reviewsState._uploadedVoiceDurationMs = data.voiceDurationMs;
        if (data.voiceWaveform) reviewsState._uploadedVoiceWaveform = data.voiceWaveform;
      }
      // Photos are tracked per slot (rfPhotoSlots) so a removed photo is never submitted.
      return data;
    });
}

// ===== VOICE RECORDING (step 2) =====

(function initVoice() {
  var mediaRecorder = null;
  var audioChunks = [];
  var audioCtx = null;
  var analyser = null;
  var animFrameId = null;
  var recordingTimer = null;
  var recordingSeconds = 0;
  var voiceBlob = null;

  var recordBtn = rf$('btnVoiceRecord');
  var stopBtn = rf$('btnStopRecord');
  var reRecordBtn = rf$('btnReRecord');
  var deleteBtn = rf$('btnDeleteVoice');
  var recordingUI = rf$('voiceRecordingUI');
  var previewUI = rf$('voicePreviewUI');
  var timerEl = rf$('voiceRecordTimer');
  var canvas = rf$('voiceRecordCanvas');
  var previewAudio = rf$('voicePreviewAudio');

  if (!recordBtn) return;

  if (!navigator.mediaDevices || !window.MediaRecorder) {
    var section = rf$('voiceRecordSection');
    if (section) section.hidden = true;
    return;
  }

  function getMimeType() {
    if (MediaRecorder.isTypeSupported('audio/webm;codecs=opus')) return 'audio/webm;codecs=opus';
    if (MediaRecorder.isTypeSupported('audio/webm')) return 'audio/webm';
    if (MediaRecorder.isTypeSupported('audio/mp4')) return 'audio/mp4';
    return '';
  }

  function startRecording() {
    var mimeType = getMimeType();
    rfPhotoError('');
    if (!mimeType) { rfPhotoError(pltxT('pltx2.js.k020', 'הדפדפן אינו תומך בהקלטה')); return; }

    navigator.mediaDevices.getUserMedia({ audio: true }).then(function (stream) {
      recordBtn.hidden = true;
      recordingUI.hidden = false;
      audioChunks = [];
      recordingSeconds = 0;
      timerEl.textContent = '00:00/3:00';

      audioCtx = new (window.AudioContext || window.webkitAudioContext)();
      var source = audioCtx.createMediaStreamSource(stream);
      analyser = audioCtx.createAnalyser();
      analyser.fftSize = 256;
      source.connect(analyser);

      var ctx = canvas.getContext('2d');
      var bufferLength = analyser.frequencyBinCount;
      var dataArray = new Uint8Array(bufferLength);

      function drawWaveform() {
        analyser.getByteFrequencyData(dataArray);
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        var barWidth = canvas.width / bufferLength * 2;
        var x = 0;
        for (var i = 0; i < bufferLength; i++) {
          var barHeight = (dataArray[i] / 255) * canvas.height * 0.8;
          var y = (canvas.height - barHeight) / 2;
          ctx.fillStyle = '#aeb9ff';
          ctx.fillRect(x, y, barWidth - 1, barHeight);
          x += barWidth;
          if (x > canvas.width) break;
        }
        animFrameId = requestAnimationFrame(drawWaveform);
      }
      drawWaveform();

      mediaRecorder = new MediaRecorder(stream, { mimeType: mimeType });
      mediaRecorder.ondataavailable = function (e) { if (e.data.size > 0) audioChunks.push(e.data); };
      mediaRecorder.onstop = function () {
        stream.getTracks().forEach(function (t) { t.stop(); });
        cancelAnimationFrame(animFrameId);
        if (audioCtx) { audioCtx.close().catch(function () {}); audioCtx = null; }
        voiceBlob = new Blob(audioChunks, { type: mimeType });
        showPreview();
      };
      mediaRecorder.start();

      recordingTimer = setInterval(function () {
        recordingSeconds++;
        var m = Math.floor(recordingSeconds / 60);
        var s = recordingSeconds % 60;
        timerEl.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s + '/3:00';
        if (recordingSeconds >= 180) stopRecording();
      }, 1000);
    }).catch(function (err) {
      console.error('[PLTX Voice] Mic error:', err.name, err.message);
      if (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError') {
        rfPhotoError(pltxT('pltx2.js.k040', 'לא ניתן לגשת למיקרופון. אנא אשרי גישה בהגדרות הדפדפן.'));
      } else if (err.name === 'NotFoundError') {
        rfPhotoError(pltxT('pltx2.js.k041', 'לא נמצא מיקרופון במכשיר.'));
      } else {
        rfPhotoError(pltxT('pltx2.js.k085', 'שגיאה בהפעלת המיקרופון: ') + err.message);
      }
    });
  }

  function stopRecording() {
    if (mediaRecorder && mediaRecorder.state === 'recording') mediaRecorder.stop();
    clearInterval(recordingTimer);
  }

  function showPreview() {
    recordingUI.hidden = true;
    previewUI.hidden = false;
    if (!voiceBlob) return;
    previewAudio.src = URL.createObjectURL(voiceBlob);
    // Upload now so submitting never waits on it.
    uploadReviewMedia(voiceBlob, 'voice').catch(function (err) {
      console.error('Voice upload failed:', err);
      rfPhotoError(pltxT('pltx2.js.k084', 'שגיאה בהעלאת ההקלטה'));
    });
  }

  function resetRecording() {
    stopRecording();
    previewUI.hidden = true;
    recordingUI.hidden = true;
    recordBtn.hidden = false;
    voiceBlob = null;
    reviewsState._uploadedVoiceUrl = null;
    reviewsState._uploadedVoiceDurationMs = null;
    reviewsState._uploadedVoiceWaveform = [];
    if (previewAudio.src) { URL.revokeObjectURL(previewAudio.src); previewAudio.removeAttribute('src'); }
  }
  window.pltx2RfResetVoice = resetRecording;

  recordBtn.addEventListener('click', startRecording);
  if (stopBtn) stopBtn.addEventListener('click', stopRecording);
  if (reRecordBtn) reRecordBtn.addEventListener('click', function () { resetRecording(); startRecording(); });
  if (deleteBtn) deleteBtn.addEventListener('click', resetRecording);
})();
